import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StyledAppHeader } from './AppHeader.styles';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';
import { RoutePaths } from 'config/route-paths';
import { Logout } from 'app/components/Logout/Logout';

interface AppHeaderProps {
  collapsed: boolean;
  onToggleSider: () => void;
  onOpenMobileNav: () => void;
}

export const AppHeader = ({ collapsed, onToggleSider, onOpenMobileNav }: AppHeaderProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledAppHeader>
      <p className="app-header__title">{t('navigation.productName')}</p>
      <div className="app-header__row">
        <div className="app-header__section app-header__section--left">
          <button
            type="button"
            onClick={onToggleSider}
            className="app-header__toggle app-header__toggle--desktop"
            aria-label="Toggle navigation"
            aria-expanded={!collapsed}
          >
            <SvgIcon name={collapsed ? 'menuExpand' : 'menuCollapse'} className="app-header__toggle-icon" />
          </button>
          <button
            type="button"
            onClick={onOpenMobileNav}
            className="app-header__toggle app-header__toggle--mobile"
            aria-label="Open navigation"
          >
            <SvgIcon name="menu" className="app-header__toggle-icon" />
          </button>
        </div>

        <div className="app-header__section app-header__section--center">
          <Link to={RoutePaths.ROOT} aria-label={t('navigation.productName')}>
            <SvgIcon name="karcherLogo" className="app-header__logo" />
          </Link>
        </div>

        <div className="app-header__section app-header__section--right">
          <Logout />
        </div>
      </div>
    </StyledAppHeader>
  );
};
